const { prospect, inquiry, application, aid } = require('./ethosModels');

const richTextEditorPlaceholdersByTemplate = {
    inquiry: [
        { id: 'first-name', model: inquiry.name, attribute: '/firstName' },
        { id: 'last-name', model: inquiry.name, attribute: '/lastName' },
        { id: 'email', model: inquiry.name, attribute: '/[emails]/address' },
        { id: 'phone-number', model: inquiry.name, attribute: '/[phones]/number' },
        { id: 'academic-program', model: inquiry.name, attribute: '/[academicPrograms]', isDA: true },
        { id: 'academic-term', model: inquiry.name, attribute: '/entryAcademicPeriod', isDA: true },
        { id: 'preferred-name', model: inquiry.name, attribute: '/preferredName' }
    ],
    prospect: [
        { id: 'first-name', model: prospect.name, attribute: 'firstName' },
        { id: 'last-name', model: prospect.name, attribute: 'lastName' },
        { id: 'email', model: prospect.name, attribute: 'email' },
        { id: 'phone-number', model: prospect.name, attribute: 'phone' },
        { id: 'preferred-name', model: prospect.name, attribute: 'preferredName' },
    ],
    application: [
        { id: 'first-name', model: application.name, attribute: '/name/firstName' },
        { id: 'last-name', model: application.name, attribute: '/name/lastName' },
        { id: 'email', model: application.name, attribute: '/[emails]/address' },
        { id: 'phone-number', model: application.name, attribute: '/[phones]/number' },
        { id: 'academic-program', model: application.name, attribute: '/enrollment/[academicPrograms]', isDA: true },
        { id: 'academic-term', model: application.name, attribute: '/enrollment/academicPeriod', isDA: true },
        { id: 'preferred-name', model: application.name, attribute: '/name/preferredName' }
    ],
    aid: [
        { id: 'first-name', model: aid.name, attribute: '/name/firstName' },
        { id: 'last-name', model: aid.name, attribute: '/name/lastName' },
        { id: 'email', model: aid.name, attribute: '/[emails]/address' },
        { id: 'phone-number', model: aid.name, attribute: '/[phones]/number' },
        { id: 'preferred-name', model: aid.name, attribute: '/name/preferredName' }
    ]
}

module.exports = { richTextEditorPlaceholdersByTemplate };
